export type HuntConstraints = {
  huntCutoffHours: number | null
  maxDaysOut: number | null
  maxActiveHunts: number | null
  maxActiveHuntsBypassHours: number | null
  daysPerHunt: number | null
  overageCapDollars: number | null
  minBirdsPerHunter: number | null
  autoInvoiceOverage: boolean
  occupancyBlockingEnabled: boolean
  huntPackagesEnabled: boolean
  autoDeductConsumablesAtCutoff: boolean
}

const MINUTES_PER_DAY = 24 * 60

export type MemberHuntWindow =
  | { kind: 'unrestricted' }
  | { kind: 'daily'; closesAtMinutes: number }
  | { kind: 'closed' }

export function memberHuntWindow(
  huntCutoffHours: number | null,
  maxDaysOut: number | null,
  blockStartMinutes: number | null,
): MemberHuntWindow {
  if (huntCutoffHours === null || maxDaysOut === null) {
    return { kind: 'unrestricted' }
  }
  const closesAtMinutes =
    maxDaysOut * MINUTES_PER_DAY + (blockStartMinutes ?? 0) - huntCutoffHours * 60
  if (closesAtMinutes <= 0) return { kind: 'closed' }
  if (closesAtMinutes >= MINUTES_PER_DAY) return { kind: 'unrestricted' }
  return { kind: 'daily', closesAtMinutes }
}

export function parseClockMinutes(time: string): number | null {
  const match = /^(\d{1,2}):(\d{2})/.exec(time.trim())
  if (!match) return null
  const hours = Number(match[1])
  const minutes = Number(match[2])
  if (hours > 23 || minutes > 59) return null
  return hours * 60 + minutes
}
